var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "checkoutpage-component" }, [
    _vm.order && _vm.order.status == "new"
      ? _c("div", { staticClass: "checkout-page__body" }, [
          _c("div", { staticClass: "checkout-page__content" }, [
            _c("div", { staticClass: "checkout-page__forms" }, [
              _vm.order
                ? _c("div", { staticClass: "checkout-form" }, [
                    _c(
                      "div",
                      {
                        staticClass: "checkout-form__group checkout-form-group",
                        class: {
                          "checkout-form-group--expanded":
                            _vm.order.stage == "start",
                        },
                      },
                      [
                        _vm._m(0),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "checkout-form-group__body",
                            class: {
                              "checkout-form-group__body--expanded":
                                _vm.order.stage == "start",
                            },
                          },
                          [
                            _c(
                              "ul",
                              {
                                staticClass:
                                  "checkout-form-group__tabs client-info-tabs",
                              },
                              [
                                _c(
                                  "li",
                                  {
                                    staticClass:
                                      "client-info-tabs__item client-tab",
                                    class: {
                                      "client-info-tabs__item--active":
                                        _vm.activeTab == "CheckoutPersonalForm",
                                    },
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "client-tab__btn",
                                        class: {
                                          "client-tab__btn--active":
                                            _vm.activeTab ==
                                            "CheckoutPersonalForm",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeTab(
                                              "CheckoutPersonalForm",
                                              "personal"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Физическое лицо")]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  {
                                    staticClass:
                                      "client-info-tabs__item client-tab",
                                    class: {
                                      "client-info-tabs__item--active":
                                        _vm.activeTab ==
                                        "CheckoutCorporateForm",
                                    },
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "client-tab__btn",
                                        class: {
                                          "client-tab__btn--active":
                                            _vm.activeTab ==
                                            "CheckoutCorporateForm",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeTab(
                                              "CheckoutCorporateForm",
                                              "corporate"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Юридическое лицо")]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(_vm.activeTab, {
                              tag: "component",
                              attrs: { order: _vm.order, errors: _vm.errors },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "checkout-form-group__actions" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-primary checkout-form-group__next-btn",
                                    on: {
                                      click: function ($event) {
                                        return _vm.saveOrder("delivery")
                                      },
                                    },
                                  },
                                  [_vm._v("Далее")]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.order.stage != "start"
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "checkout-form-group__filled-body filled-fields",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "filled-fields__item" },
                                  [_vm._v(_vm._s(_vm.order.first_name))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "filled-fields__item" },
                                  [_vm._v(_vm._s(_vm.order.phone))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "filled-fields__item" },
                                  [_vm._v(_vm._s(_vm.order.email))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "filled-fields__actions" },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-outline--tertiary edit-checkout-btn",
                                        on: {
                                          click: function ($event) {
                                            return _vm.saveOrder("start")
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa fa-pencil edit-checkout-btn__icon",
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "edit-checkout-btn__text",
                                          },
                                          [_vm._v("Изменить")]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "checkout-form__group checkout-form-group",
                        class: {
                          "checkout-form-group--expanded":
                            _vm.order.stage == "delivery",
                        },
                      },
                      [
                        _vm._m(1),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "checkout-form-group__body",
                            class: {
                              "checkout-form-group__body--expanded":
                                _vm.order.stage == "delivery",
                            },
                          },
                          [
                            _vm.order && _vm.order.id
                              ? _c("checkout-delivery-form", {
                                  attrs: {
                                    order: _vm.order,
                                    errors: _vm.errors,
                                  },
                                  on: { "on-select": _vm.selectDelivery },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "checkout-form-group__actions" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-primary checkout-form-group__next-btn",
                                    on: {
                                      click: function ($event) {
                                        return _vm.saveOrder("payment")
                                      },
                                    },
                                  },
                                  [_vm._v("Далее")]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.order.stage != "delivery" && _vm.order.delivery
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "checkout-form-group__filled-body filled-fields",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "filled-fields__item" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.order.delivery_instance.name)
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "filled-fields__actions" },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-outline--tertiary edit-checkout-btn",
                                        on: {
                                          click: function ($event) {
                                            return _vm.saveOrder("delivery")
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa fa-pencil edit-checkout-btn__icon",
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "edit-checkout-btn__text",
                                          },
                                          [_vm._v("Изменить")]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "checkout-form__group checkout-form-group",
                        class: {
                          "checkout-form-group--expanded":
                            _vm.order.stage == "payment",
                        },
                      },
                      [
                        _vm._m(2),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "checkout-form-group__body",
                            class: {
                              "checkout-form-group__body--expanded":
                                _vm.order.stage == "payment",
                            },
                          },
                          [
                            _vm.order && _vm.order.id
                              ? _c("checkout-payment-form", {
                                  attrs: {
                                    order: _vm.order,
                                    errors: _vm.errors,
                                  },
                                  on: { "on-select": _vm.selectPayment },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "checkout-form-group__actions" },
                              [
                                _vm.order.payment_code != "ONLINE"
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-info checkout-form-group__complete-btn",
                                        on: {
                                          click: function ($event) {
                                            return _vm.saveOrder("finish")
                                          },
                                        },
                                      },
                                      [_vm._v("Отправить заказа")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.order.payment_code == "ONLINE"
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-success checkout-form-group__complete-btn",
                                        on: {
                                          click: function ($event) {
                                            return _vm.saveOrder("to_bank")
                                          },
                                        },
                                      },
                                      [_vm._v("Оплатить онлайн")]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.order.stage != "payment" && _vm.order.payment
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "checkout-form-group__filled-body filled-fields",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "filled-fields__item" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.order.payment_instance.name)
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "filled-fields__actions" },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-outline--tertiary edit-checkout-btn",
                                        on: {
                                          click: function ($event) {
                                            return _vm.saveOrder("payment")
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa fa-pencil edit-checkout-btn__icon",
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "edit-checkout-btn__text",
                                          },
                                          [_vm._v("Изменить")]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "checkout-page__aside" }, [
            _vm.order && _vm.order.request_cart
              ? _c(
                  "div",
                  {
                    staticClass:
                      "summary-cart-info summary-cart-info--checkout-page",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "summary-cart-info__checkout-header" },
                      [_vm._v("\n          Ваш заказ\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "summary-cart-info__part summary-cart-info__part--products",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "summary-cart-info__block-title" },
                          [_vm._v("Корзина")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "summary-cart-info__part-content" },
                          [
                            _c("div", { staticClass: "summary-products" }, [
                              _c(
                                "div",
                                { staticClass: "summary-products__row" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "summary-products__label" },
                                    [
                                      _vm._v(
                                        "Товары (" +
                                          _vm._s(
                                            _vm.order.request_cart.counts
                                          ) +
                                          ")"
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "summary-products__price" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatNumberWithSpaces(
                                            _vm.order.request_cart.raw_summary
                                          )
                                        ) + " руб.\n                "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.order.request_cart.profit_cart
                                ? _c(
                                    "div",
                                    { staticClass: "summary-products__row" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "summary-products__label",
                                        },
                                        [_vm._v("Скидка")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "summary-products__price summary-products__price--sale",
                                        },
                                        [
                                          _vm._v(
                                            "-" +
                                              _vm._s(
                                                _vm.formatNumberWithSpaces(
                                                  _vm.order.request_cart
                                                    .profit_cart
                                                )
                                              ) +
                                              " руб."
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "summary-cart-info__part summary-cart-info__part--products",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "summary-cart-info__block-title" },
                          [_vm._v("Доставка")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "summary-cart-info__part-content" },
                          [
                            _c("div", { staticClass: "summary-products" }, [
                              _vm.order.delivery_instance
                                ? _c(
                                    "div",
                                    { staticClass: "summary-products__row" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "summary-products__label",
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.order.delivery_instance.name
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.order.delivery_instance
                                        .calculated_price
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "summary-products__price",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatNumberWithSpaces(
                                                    _vm.order.delivery_instance
                                                      .calculated_price
                                                  )
                                                ) + " руб."
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.order.delivery_instance
                                        .calculated_price
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "summary-products__price",
                                            },
                                            [_vm._v("Без доплат")]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.order.summary_with_delivery
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "summary-cart-info__part summary-cart-info__part--summary-payment",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "summary-cart-info__row summary-cart-price",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "summary-cart-price__label" },
                                  [_vm._v("К оплате")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "summary-cart-price__value" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatNumberWithSpaces(
                                          _vm.order.summary_with_delivery
                                        )
                                      ) + " руб."
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.order &&
    [
      "sended",
      "pending",
      "payed",
      "process",
      "completed",
      "canceled",
      "returned",
    ].includes(_vm.order.status)
      ? _c("div", { staticClass: "checkout-page__body" }, [
          _c("div", { staticClass: "checkout-page__fullpage-text" }, [
            _c("p", [
              _vm._v(
                "Ваш заказ успешно отправлен! Менеджер свяжется с вами для уточнения деталей доставки и оплаты."
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "checkout-page__order-info order-info" }, [
              _c("div", { staticClass: "order-info__block" }, [
                _vm.order.link_password
                  ? _c("div", { staticClass: "order-info__password-link" }, [
                      _c(
                        "div",
                        { staticClass: "order-info__password-link-label" },
                        [_vm._v("Ссылка на заказ:")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "order-info__password-link-value" },
                        [_vm._v(_vm._s(_vm.order.get_absolute_url))]
                      ),
                      _vm._v(" "),
                      !_vm.copied
                        ? _c(
                            "button",
                            {
                              staticClass: "order-info__copy-link",
                              attrs: {
                                title: "Скопировать ссылку на заказ",
                                type: "button",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.getPasswordLink()
                                },
                              },
                            },
                            [_c("i", { staticClass: "fa fa-copy" })]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.copied
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "order-info__copy-link order-info__copy-link--success",
                              attrs: {
                                title: "Скопировать ссылку на заказа",
                                type: "button",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.getPasswordLink()
                                },
                              },
                            },
                            [_c("i", { staticClass: "fa fa-check" })]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("dl", { staticClass: "order-info__chars" }, [
                  _c("dt", { staticClass: "order-info__char-label" }, [
                    _vm._v("Статус"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "dd",
                    {
                      staticClass: "order-info__char-value",
                      class: "order-info__char-value--" + _vm.order.status,
                    },
                    [_vm._v(_vm._s(_vm.order.get_status_display))]
                  ),
                  _vm._v(" "),
                  _c("dt", { staticClass: "order-info__char-label" }, [
                    _vm._v("Номер заказа"),
                  ]),
                  _vm._v(" "),
                  _c("dd", { staticClass: "order-info__char-value" }, [
                    _vm._v(_vm._s(_vm.order.order_number)),
                  ]),
                  _vm._v(" "),
                  _c("dt", { staticClass: "order-info__char-label" }, [
                    _vm._v("Дата"),
                  ]),
                  _vm._v(" "),
                  _c("dd", { staticClass: "order-info__char-value" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("moment")(_vm.order.created_at, "D MMM YYYY")
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("dt", { staticClass: "order-info__char-label" }, [
                    _vm._v("Стоимость товаров"),
                  ]),
                  _vm._v(" "),
                  _c("dd", { staticClass: "order-info__char-value" }, [
                    _vm._v(
                      _vm._s(
                        _vm.formatNumberWithSpaces(_vm.order.cart_summary)
                      ) + " руб."
                    ),
                  ]),
                  _vm._v(" "),
                  _c("dt", { staticClass: "order-info__char-label" }, [
                    _vm._v("Сумма с доставкой"),
                  ]),
                  _vm._v(" "),
                  _c("dd", { staticClass: "order-info__char-value" }, [
                    _vm._v(
                      _vm._s(
                        _vm.formatNumberWithSpaces(
                          _vm.order.summary_with_delivery
                        )
                      ) + " руб."
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _vm.order.status == "pending" && _vm.order.payment_form_url
                  ? _c("div", { staticClass: "order-info__pay-action" }, [
                      _c(
                        "a",
                        {
                          staticClass: "btn btn-primary",
                          attrs: { href: _vm.order.payment_form_url },
                        },
                        [_vm._v("Оплатить онлайн")]
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm.order.delivery_instance
                ? _c(
                    "div",
                    { staticClass: "order-info__delivery order-info__block" },
                    [
                      _c("h2", { staticClass: "order-info__block-name" }, [
                        _vm._v("Доставка"),
                      ]),
                      _vm._v(" "),
                      _c("dl", { staticClass: "order-info__chars" }, [
                        _c("dt", { staticClass: "order-info__char-label" }, [
                          _vm._v(_vm._s(_vm.order.delivery_instance.name)),
                        ]),
                        _vm._v(" "),
                        _c("dd", { staticClass: "order-info__char-value" }, [
                          _vm._v(_vm._s(_vm.order.delivery_instance.help_text)),
                        ]),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.order.payment_instance
                ? _c(
                    "div",
                    { staticClass: "order-info__delivery order-info__block" },
                    [
                      _c("h2", { staticClass: "order-info__block-name" }, [
                        _vm._v("Оплата"),
                      ]),
                      _vm._v(" "),
                      _c("dl", { staticClass: "order-info__chars" }, [
                        _c("dt", { staticClass: "order-info__char-label" }, [
                          _vm._v(_vm._s(_vm.order.payment_instance.name)),
                        ]),
                        _vm._v(" "),
                        _c("dd", { staticClass: "order-info__char-value" }, [
                          _vm._v(_vm._s(_vm.order.payment_instance.help_text)),
                        ]),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.order.products
                ? _c(
                    "div",
                    {
                      staticClass:
                        "order-info__products order-info__block cart-products",
                    },
                    [
                      _c("h2", { staticClass: "order-info__block-name" }, [
                        _vm._v("Товары"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "cart-products__items" },
                        _vm._l(_vm.order.products, function (item) {
                          return _c(
                            "div",
                            {
                              key: "cart_item" + item.id,
                              staticClass: "cart-products__item",
                            },
                            [
                              _c("div", { staticClass: "cart-product-item" }, [
                                _c(
                                  "div",
                                  { staticClass: "cart-product-item__icon" },
                                  [
                                    _c("img", {
                                      staticClass: "cart-product-item__img",
                                      attrs: {
                                        src: _vm.baseUrl + item.thumbnail,
                                        alt: item.name,
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "cart-product-item__content" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "cart-product-item__main-info",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "cart-product-item__name",
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "cart-product-item__link",
                                                attrs: {
                                                  href: item.get_absolute_url,
                                                  target: "_blank",
                                                },
                                              },
                                              [_vm._v(_vm._s(item.name))]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "ul",
                                          {
                                            staticClass:
                                              "cart-product-item__labels",
                                          },
                                          [
                                            item.sale_percent
                                              ? _c(
                                                  "li",
                                                  {
                                                    staticClass:
                                                      "cart-product-item__label product-label product-label--sale",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "product-label__text product-label__text--sale",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "-" +
                                                            _vm._s(
                                                              item.sale_percent.toFixed(
                                                                0
                                                              )
                                                            ) +
                                                            "%"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "cart-product-item__price-area",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "cart-product-item__price",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatNumberWithSpaces(
                                                  item.total_price.toFixed(0)
                                                )
                                              ) + " руб."
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        item.profit
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "cart-product-item__price-raw",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatNumberWithSpaces(
                                                      item.raw_total_price.toFixed(
                                                        0
                                                      )
                                                    )
                                                  ) + " руб."
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          )
                        }),
                        0
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "checkout-form-group__header" }, [
      _c("div", { staticClass: "checkout-form-group__name" }, [
        _vm._v("Покупатель"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "checkout-form-group__header" }, [
      _c("div", { staticClass: "checkout-form-group__name" }, [
        _vm._v("Способ получения"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "checkout-form-group__header" }, [
      _c("div", { staticClass: "checkout-form-group__name" }, [
        _vm._v("Способ оплаты"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }